function CrosswordGame() {
  return (
    <div
      style={{
        width: '100%',
        padding: '24px',
        border: '2px dashed #bbb',
        borderRadius: '8px',
        background: '#fafafa',
        textAlign: 'center',
      }}
    >
      <h2 style={{ margin: 0 }}>Crossword</h2>
      <p style={{ marginTop: '8px', color: '#555' }}>
        Game coming soon. This is a placeholder component.
      </p>
    </div>
  );
}

export default CrosswordGame;
